import { useQuery } from "@tanstack/react-query"
import ResponseError from "#/types/responseError"
import { getContentfulClient } from "#/lib/contentful/contentfulClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import { useIntl } from "react-intl"
import { getContentfulLocale } from "#/lib/contentful/utils/contentfulLocaleUtils"
import { TypeCollectiveItem, TypeCollectiveItemSkeleton } from "#/types/contentful"

const client = getContentfulClient()
const ENDPOINT = "GetCollectiveItems"

type CollectiveItemEntry = TypeCollectiveItem<"WITHOUT_UNRESOLVABLE_LINKS">

const loadCollectiveItems = async (locale: string) => {
  const { items } = await client.withoutUnresolvableLinks.getEntries<TypeCollectiveItemSkeleton>({
    content_type: "collectiveItem",
    include: 10,
    locale: getContentfulLocale(locale)
  })

  return items
}

const getCollectiveItemsCacheKey = (): (string | number)[] => [ENDPOINT]

export default function useCollectiveItems() {
  const intl = useIntl()
  const { locale } = intl

  return useQuery<CollectiveItemEntry[], ResponseError>(
    getCollectiveItemsCacheKey(),
    () => loadCollectiveItems(locale),
    {
      refetchOnWindowFocus: false,
      retry: buildCarrotApiRetryPolicy(3)
    }
  )
}
